<mat-selection-list #matSelection role="list" class="list-plantillas" (selectionChange)="getSelected($event)">
  <mat-list-option *ngFor="let item of listPlantillasJornadas" [value]="item">
    {{ item.IdPlantillaJornada + ' - ' + item.NplantillaJornada }}
  </mat-list-option>
</mat-selection-list>